import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';
import { BlockDayForm } from './block-day-form';
import IntlProviderHOC from '../../app-main/containers/IntlProviderHOC';
import { Text } from '@ps-design-system/components/Text';

export class BlockDayModal extends React.Component {
  render () {
    const { toggleBlockDayModal, showModal, country, callFetchCalendar } = this.props;
    return (
      <BootstrapModal
        showModal={showModal}
        modalClass="block-time-modal"
        onClose={toggleBlockDayModal}
        header={
          <div>
            <h2>
              <FormattedMessage
                id="hosting.calendar_main.bootstrap_modal_header_heading"
                defaultMessage="Block time"
              />
            </h2>
            <p>
              <FormattedMessage
                id="hosting.calendar_main.bootstrap_modal_header_text"
                defaultMessage="Your space will be marked unavailable."
              />
            </p>
          </div>
        }
        body={
          <IntlProviderHOC>
            <BlockDayForm
              {...this.props}
              toggleModal={toggleBlockDayModal}
              callFetchCalendar={callFetchCalendar}
              country={country}
            />
          </IntlProviderHOC>
        }
        footer={
          <div className='blocked-footer'>
            <div className='footer-description tw-text-gray-600'>
              <Text typeface="body-2" >
                <FormattedMessage id="deactivate.modal.renovating" defaultMessage="Renovating your space or heading out on a long trip? Whatever the reason, if you need to temporarily stop bookings, consider pausing your listing. It stays visible but won't be available to book."/>
                {' '}
                <a className='footer-link tw-text-gray-600' href="https://support.peerspace.com/en/articles/11380453-host-performance-guide" target="_blank" rel="noopener noreferrer"><FormattedMessage id="uploader.three_d_tour_modal.description_link" defaultMessage="Learn more" /></a>
              </Text>
            </div>
          </div>
        }
      />
    );
  }
}

BlockDayModal.propTypes = {
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func
};
